import React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import type { FormsAlertBody } from '../alertHover.types'
import { formsStyles } from './Forms.styles'
import { useTranslation } from 'react-i18next'

const FormsBody: React.FC<{ body: FormsAlertBody }> = ({ body }) => {
  const { t } = useTranslation('alerts')

  if (!body) {
    return null
  }

  return (
    <Box sx={formsStyles.root}>
      <Box sx={formsStyles.row}>
        <Typography sx={formsStyles.value}>{body?.pendingCount ?? 0}</Typography>
        <Typography sx={formsStyles.label}>{t('forms.pending')}</Typography>
      </Box>
    </Box>
  )
}

export default FormsBody
